// SPDX-FileCopyrightText: Copyright 2024 Dash0 Inc.

import { createContext, ReactNode } from "react";

import { Index, Kind } from "@/hub/types";

/**
 * Context interface for providing hub resource information to MDX components
 */
export interface HubResourceContextValue {
    /** The kind of resource (e.g., "PersesDashboard", "Dash0Integration") */
    resourceKind: Kind;
    /** The ID of the resource */
    resourceId: string;
    index: Index;
}

/**
 * Context for providing hub resource information to MDX components
 */
export const HubResourceContext = createContext<HubResourceContextValue | null>(null);

interface HubResourceProviderProps {
    resourceKind: Kind;
    resourceId: string;
    index: Index;
    children: ReactNode;
}

/**
 * Provider component for setting hub resource context
 */
export function HubResourceProvider({ resourceKind, resourceId, index, children }: HubResourceProviderProps) {
    return (
            <HubResourceContext.Provider value={{ resourceKind, resourceId, index }}>
                {children}
            </HubResourceContext.Provider>
    );
}